/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface CancelStuckWorkflowRequest {
    workflowId: string;
}

export interface CancelWorkflowRequest {
    workflowId: string;
}

export interface GetWorkflowStatusRequest {
    workflowId: string;
}

export interface IsWorkflowStuckRequest {
    workflowId: string;
    maxDurationHours?: number;
    maxRetryAttempts?: number;
}

export interface TerminateWorkflowRequest {
    workflowId: string;
    reason?: string;
}

/**
 * TemporalWorkflowManagementApi - interface
 * 
 * @export
 * @interface TemporalWorkflowManagementApiInterface
 */
export interface TemporalWorkflowManagementApiInterface {
    /**
     * Cancel a stuck workflow. Attempts graceful cancellation first, then forces termination if cancellation fails.
     * @summary Cancel stuck workflow
     * @param {string} workflowId Workflow ID to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemporalWorkflowManagementApiInterface
     */
    cancelStuckWorkflowRaw(requestParameters: CancelStuckWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Cancel a stuck workflow. Attempts graceful cancellation first, then forces termination if cancellation fails.
     * Cancel stuck workflow
     */
    cancelStuckWorkflow(requestParameters: CancelStuckWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Cancel a running workflow execution. This is a graceful operation that allows the workflow to clean up.
     * @summary Cancel workflow
     * @param {string} workflowId Workflow ID to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemporalWorkflowManagementApiInterface
     */
    cancelWorkflowRaw(requestParameters: CancelWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Cancel a running workflow execution. This is a graceful operation that allows the workflow to clean up.
     * Cancel workflow
     */
    cancelWorkflow(requestParameters: CancelWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get the current status of a workflow execution
     * @summary Get workflow status
     * @param {string} workflowId Workflow ID to query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemporalWorkflowManagementApiInterface
     */
    getWorkflowStatusRaw(requestParameters: GetWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get the current status of a workflow execution
     * Get workflow status
     */
    getWorkflowStatus(requestParameters: GetWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Analyze a workflow to determine if it\'s stuck based on duration, retry attempts, and pending activities
     * @summary Check if workflow is stuck
     * @param {string} workflowId Workflow ID to check
     * @param {number} [maxDurationHours] Maximum expected duration in hours
     * @param {number} [maxRetryAttempts] Maximum acceptable retry attempts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemporalWorkflowManagementApiInterface
     */
    isWorkflowStuckRaw(requestParameters: IsWorkflowStuckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Analyze a workflow to determine if it\'s stuck based on duration, retry attempts, and pending activities
     * Check if workflow is stuck
     */
    isWorkflowStuck(requestParameters: IsWorkflowStuckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Terminate a workflow execution immediately. This is a forceful operation that stops the workflow without cleanup.
     * @summary Terminate workflow
     * @param {string} workflowId Workflow ID to terminate
     * @param {string} [reason] Optional reason for termination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemporalWorkflowManagementApiInterface
     */
    terminateWorkflowRaw(requestParameters: TerminateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Terminate a workflow execution immediately. This is a forceful operation that stops the workflow without cleanup.
     * Terminate workflow
     */
    terminateWorkflow(requestParameters: TerminateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class TemporalWorkflowManagementApi extends runtime.BaseAPI implements TemporalWorkflowManagementApiInterface {

    /**
     * Cancel a stuck workflow. Attempts graceful cancellation first, then forces termination if cancellation fails.
     * Cancel stuck workflow
     */
    async cancelStuckWorkflowRaw(requestParameters: CancelStuckWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling cancelStuckWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/temporal/workflows/{workflowId}/cancel-stuck`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancel a stuck workflow. Attempts graceful cancellation first, then forces termination if cancellation fails.
     * Cancel stuck workflow
     */
    async cancelStuckWorkflow(requestParameters: CancelStuckWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cancelStuckWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel a running workflow execution. This is a graceful operation that allows the workflow to clean up.
     * Cancel workflow
     */
    async cancelWorkflowRaw(requestParameters: CancelWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling cancelWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/temporal/workflows/{workflowId}/cancel`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancel a running workflow execution. This is a graceful operation that allows the workflow to clean up.
     * Cancel workflow
     */
    async cancelWorkflow(requestParameters: CancelWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cancelWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the current status of a workflow execution
     * Get workflow status
     */
    async getWorkflowStatusRaw(requestParameters: GetWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling getWorkflowStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/temporal/workflows/{workflowId}/status`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get the current status of a workflow execution
     * Get workflow status
     */
    async getWorkflowStatus(requestParameters: GetWorkflowStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWorkflowStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Analyze a workflow to determine if it\'s stuck based on duration, retry attempts, and pending activities
     * Check if workflow is stuck
     */
    async isWorkflowStuckRaw(requestParameters: IsWorkflowStuckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling isWorkflowStuck().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['maxDurationHours'] != null) {
            queryParameters['maxDurationHours'] = requestParameters['maxDurationHours'];
        }

        if (requestParameters['maxRetryAttempts'] != null) {
            queryParameters['maxRetryAttempts'] = requestParameters['maxRetryAttempts'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/temporal/workflows/{workflowId}/stuck`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Analyze a workflow to determine if it\'s stuck based on duration, retry attempts, and pending activities
     * Check if workflow is stuck
     */
    async isWorkflowStuck(requestParameters: IsWorkflowStuckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.isWorkflowStuckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Terminate a workflow execution immediately. This is a forceful operation that stops the workflow without cleanup.
     * Terminate workflow
     */
    async terminateWorkflowRaw(requestParameters: TerminateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling terminateWorkflow().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reason'] != null) {
            queryParameters['reason'] = requestParameters['reason'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/admin/temporal/workflows/{workflowId}/terminate`;
        urlPath = urlPath.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Terminate a workflow execution immediately. This is a forceful operation that stops the workflow without cleanup.
     * Terminate workflow
     */
    async terminateWorkflow(requestParameters: TerminateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.terminateWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
